import { AudioInputMimeType } from 'enums/MediaInputMimeType';
import { Action } from 'redux';

import { AmendLastAsrResultAction, ClientVoiceActionType } from './clientVoice.actions';
import { LastAsrResult } from './clientVoice.types';

const initialState = {
    initialized: false,
    inputMimeType: AudioInputMimeType.MPEG,
    lastAsrResult: null as LastAsrResult | null,
};

export const clientVoiceReducer = (
    state = initialState,
    action: Action<ClientVoiceActionType>,
): typeof initialState => {
    switch (action.type) {
        case ClientVoiceActionType.SetClientVoiceInitialized: {
            return {
                ...state,
                initialized: true,
            };
        }

        case ClientVoiceActionType.AmendLastAsrResult: {
            const lastAsrResult = (action as AmendLastAsrResultAction).payload;

            return {
                ...state,
                lastAsrResult: lastAsrResult ? { ...state.lastAsrResult, ...lastAsrResult } : null,
            };
        }

        default: {
            return state;
        }
    }
};
